module.exports = __webpack_public_path__ + "img/antes_despues_162.c232c122.png";